import { meService } from '../api/services';
import { fullName } from './mappingData';

const ADMIN_ROLES = ['admin', 'superadmin'];

/**
 * Builds the signed-in admin for the auth slice.
 * The role comes ONLY from the ID token's `role` custom claim (handoff 2.2) —
 * never from the Users doc. Name and email come from `GET /me`.
 *
 * @param {import('firebase/auth').User} firebaseUser
 * @param {{ forceRefresh?: boolean }} options - force a token refresh to pick up a new claim
 * @returns {Promise<object|null>} the session user, or null when the account is not an admin
 */
export const loadAdminSession = async (firebaseUser, { forceRefresh = false } = {}) => {
    const { claims } = await firebaseUser.getIdTokenResult(forceRefresh);
    if (!ADMIN_ROLES.includes(claims.role)) return null;

    let profile = null;
    try {
        const me = await meService.get();
        profile = me?.user ?? me;
    } catch (error) {
        // The session still works without the profile; only the display name is missing.
        console.error('Error loading admin profile (GET /me):', error);
    }

    return {
        uid: firebaseUser.uid,
        email: profile?.email || firebaseUser.email,
        displayName: fullName(profile, firebaseUser.displayName || firebaseUser.email?.split('@')[0] || ''),
        photoURL: firebaseUser.photoURL,
        role: claims.role,
    };
};
